<template>
    <div>
        <HeaderSection icon="fas fa-cogs" title="Administración">
            <template slot="buttons">
                <el-button
                    size="medium"
                    type="danger"
                    icon="el-icon-arrow-left"
                    @click="$router.push('/')">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>
        <el-row :gutter="5" class="apps-container" justify="space-around">
            <el-col :span="6" v-for="(link, index) in links" :key="link.name">
                <div class="grid-content-apps">
                    <h5>
                        <router-link :to="link.route" v-if="index <= 8">
                            {{ link.name }}
                        </router-link>
                    </h5>
                    <p style="font-size: 10pt !important">{{ link.description }}</p>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import HeaderSection from '@/components/partials/HeaderSection';
    export default {
        components: {
            HeaderSection
        },
        data() {
            return {
                links: []
            }
        },

        created() {
            this.$store.dispatch(
                'loading/spinner', { msg: '', status: true }, { root: true });
            axios.get('/api/links-home').then(response => {
                this.$store.dispatch('loading/spinner', {}, { root: true });
                this.links = response.data.links[1];

            });
        },
    }
</script>
<style>
    .card-home {}

    .apps-container {
        padding: 0 10px 0 30px;
    }

    .grid-content-apps a {
        color: #9D2449;
    }

</style>
